import BaseAPI from '../BaseAPI.js'
export default class ContentPageApi extends BaseAPI {
  _resource ='pages/'

  constructor (pageName) {
    super()
    this._resource = 'pages/' + pageName
  }
}
